<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading" @on-cancel="cancel">
      <h3 slot="header" class="modal-header">转交商机</h3>
      <div style="height: 150px;position: relative;padding-left: 100px">
        <Select v-model="value" placeholder="请选择转交ZO" style="width: 200px;">
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in zoList" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
        </Select>
      </div>
    </Modal>
  </div>

</template>
<script>
  import { getProjectZos } from 'api/common'
  import {changeTakeLookZo} from "../../../../api/business";


  export default {
    name: "",
    components: {},
    props: {
      n: {
        type: Number,
        default: 0
      },
      data: {
        type: Object,
        default: null
      }

    },
    watch: {
      n() {
        this.zoList=[]

        this.value = null
        this.isShow = true
        if(this.data){
          getProjectZos(this.data.projectFid).then( res => {
            this.zoList = res.data
          }).catch(error=>{})
        }
      }
    },
    data() {
      return {
        loading: true,
        isShow: false,
        value: null,
        zoList:[],
      }
    },
    computed:{
      zoListMap(){
        let ret={}
        this.zoList.forEach(ele=>{
          ret[ele.value+'']=ele.text
        })
        return ret
      }

    },
    methods: {
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        if (!(this.value) && this.value !== 0) {
          this.$Message.info('请选择转交ZO')
          this.changeLoading()
          return
        }
        let params = {
          "businessFid": this.data.businessFid,
          "zoFid": this.value,
          "zoName": this.zoListMap[this.value+'']
        }
        changeTakeLookZo(params).then(res => {
            this.$emit('done')
            this.$Message.success('操作成功')
          }
        ).catch(error => {
          }).finally(()=>{
            this.isShow=false
        })

      },
      cancel() {

      }

    }

  }
</script>

<style scoped>

</style>
